import React from 'react'
import { compose } from 'recompose'
import { inject, observer } from 'mobx-react'
import { Slider } from 'antd'
import moment from 'moment'
import styled from 'styled-components'

const BlackSlider = styled(Slider)`
  .ant-slider-step {
    background: grey;
  }
`
// import config from '~/config'
// const { now } = config

const DataDateSearch = ({ view, data: { now } }) => {
  const today = moment(now).clone().set({ hour: 0, minute: 0, second: 0 })
  // console.log({ now, today })
  const handleOffsetChange = (value) => {
    view.setDaysOffset(value)
  }

  return <BlackSlider
    dots
    min={0}
    max={6}
    step={1}
    defaultValue={view.daysOffset || 0}
    marks={{
      // '-7': <span style={{ textShadow: '0 0 2px grey' }}>{today.clone().add(-7, 'day').format('DD/MM/YY')}</span>,
      0: <span style={{ textShadow: '0 0 2px grey' }}>today</span>,
      1: <span style={{ textShadow: '0 0 2px grey' }}>{today.clone().add(1, 'day').format('MMM DD')}</span>,
      2: <span style={{ textShadow: '0 0 2px grey' }}>{today.clone().add(2, 'day').format('MMM DD')}</span>,
      3: <span style={{ textShadow: '0 0 2px grey' }}>{today.clone().add(3, 'day').format('MMM DD')}</span>,
      4: <span style={{ textShadow: '0 0 2px grey' }}>{today.clone().add(4, 'day').format('MMM DD')}</span>,
      5: <span style={{ textShadow: '0 0 2px grey' }}>{today.clone().add(5, 'day').format('MMM DD')}</span>,
      6: <span style={{ textShadow: '0 0 2px grey' }}>{today.clone().add(6, 'day').format('MMM DD')}</span>
      //      7: <span style={{ textShadow: '0 0 2px grey' }}>{today.clone().add(7, 'day').format('MMM DD')}</span>
    }}
    included={false}
    tipFormatter={d =>
      today.clone().add(d, 'day').format('DD/MM/YY')
    }
    onChange={handleOffsetChange}
  />
}

export default compose(
  inject('data'),
  inject('view'),
  observer
)(DataDateSearch)



// WEBPACK FOOTER //
// ./src/components/DataDateSearch.js